import Typography from "@mui/material/Typography";
import {Grid, ListItemText} from "@mui/material";
import React from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import '../Styles/CompetitionInfo.css'

export default function CompetitionInfo() {
    return (
        <div>
            <Grid container>
                <Grid item sm={0} md={2}>
                </Grid>
                <Grid item sm={12} md={8}>
                    <Typography gutterBottom variant="h5" component="div">
                        Baroque Trumpet Division
                    </Typography>

                    <Typography gutterBottom variant="h6" sx={{mt: 2}} color="text.secondary">
                        Must be under 40 years old on May 1, 2026
                    </Typography>

                    <Typography sx={{mt: 2}} variant="h6" component="div">
                        1st round, video recorded (415 hz). Each entire piece must be recorded in one take. No editing between movements allowed. For pieces that include repeats, observing them is optional; if taken, they may be used to add nuance and/or ornamentation.
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Handel-Suite in D, 415 Hz, Edition free choice
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Melani Sonata á 5 in D, 415 Hz, Edition Immer, SM50581 (original string orchestration), or SM 50582 (keyboard reduction), Martin Schmid, Nagold
                        </ListItem>
                    </List>

                    <Typography sx={{mt: 0}}  variant="h6" component="div">
                        2nd round, live (415/465 hz)
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Telemann: Air de Trompette, 415 Hz, choice of facsimile or Brass Press C major version, ed.
                            Tarr
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Fantini: Choice of 1 Sonata from the final 8 sonatas (without ventholes), 465 Hz, Free
                            choice of edition
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            One piece free choice, 415 Hz or 465 Hz
                        </ListItem>
                    </List>

                    <Typography sx={{mt: 0}} variant="h6" component="div">
                        Final round, live (415 hz)
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -0, display: 'list-item'}}>
                            JS Bach, BWV 51, Aria 1 and Halleluja, 415 Hz, Free choice of edition
                        </ListItem>

                        <ListItem sx={{mt: -1, display: "list-item"}}>
                            <ListItemText
                                primary={
                                    <>
                                        <Typography variant="body1" component="span">
                                            Choose one:
                                        </Typography>
                                        <List
                                            sx={{
                                                pl: 2,
                                                listStyleType: "circle",
                                                m: 0,
                                                "& .MuiListItem-root": {
                                                    display: "list-item",
                                                    py: 0.1, // reduce vertical space between sub-items
                                                },
                                            }}
                                        >
                                            {[
                                                "G.P. Telemann Concerto in D no.1, TWV 51: D7 (all), edition Martin Schmid ed. Tarr",
                                                "J.F. Fasch, Concerto à 8 FaWV L:D1, edition McNaughtan, ed. Tarr",
                                                "J.M. Molter, Concerto No. 1, MWV VI 32, edition Brass Press, ed. Tarr",
                                                "J.M. Molter, Concerto No. 2, MWV VI 33, edition Brass Press or McNaughtan, ed. Tarr",
                                                "J.M. Molter, Concerto No. 3, MWV VI 34, edition Musica Rara (?)",
                                            ].map((item, i) => (
                                                <ListItem key={i}>
                                                    <ListItemText primary={item}/>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </>
                                }
                            />
                        </ListItem>
                    </List>

                    <Typography sx={{mt: 0}} gutterBottom variant="h5" component="div">
                        Keyed Trumpet Division
                    </Typography>

                    <Typography gutterBottom variant="h6" sx={{mt: 2}} color="text.secondary">
                        Age limit, 40 years
                    </Typography>

                    <Typography sx={{mt: 2}} variant="h6" component="div">
                        1st round, video recorded (442 hz suggested). Each entire piece must be recorded in one take. No editing between movements allowed. For pieces that include repeats, observing them is optional; if taken, they may be used to add nuance and/or ornamentation.
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            J. Haydn, 2.mov, 442 Hz, Edition R.Friedrich
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Fiala: Divertimento in D, 442 Hz, Brass Collection Ed. Tarr, Martin Schmid, Nagold
                        </ListItem>
                    </List>

                    <Typography sx={{mt: 0}} variant="h6" component="div">
                        2nd round, live (442 hz)
                    </Typography>

                    <Typography sx={{mt: 1.5, pl: 3, fontSize: '1.1em'}} gutterBottom variant="h7" component="div">
                        Choice of 2 pieces from the following four:
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Boieldieu: Divertimento in D (R.Friedrich, Martin Schmid)
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Trenkivitz: Divertimento in D (Immer, Martin Schmid, Nr. 54004)
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Höffner: Introduction et Polonaise in Eb (Immer, Martin Schmid, Nr. 54002)
                        </ListItem>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            Belloli: Divertimento in D (Immer, Martin Schmid, Nr. 54008)
                        </ListItem>
                    </List>

                    <Typography sx={{mt: 0}} variant="h6" component="div">
                        Final round, live (442 hz)
                    </Typography>

                    <List sx={{listStyleType: 'disc', pl: 5}}>
                        <ListItem sx={{mt: -1, display: 'list-item'}}>
                            J.Haydn, Konzert Es-Dur all mov. with own cadenza, 442 Hz, Edition R.Friedrich
                        </ListItem>
                    </List>

                    {/*<Link to={'https://forms.gle/3Nzkt2rfSGRpFKnM9'} target="_blank" rel="noopener noreferrer"><Button color={'secondary'} variant="contained">Ensemble Registration</Button></Link>*/}
                    <Typography sx={{mt: 1, mb: 2}} gutterBottom variant="h5" component="div">
                        Assesment Guidelines
                    </Typography>

                    <Typography sx={{mt: 0}} gutterBottom variant="h6" component="div">
                        Round one (recorded for application)
                    </Typography>
                    <Typography sx={{mt: 0, lineHeight: 1.9}} gutterBottom variant="body" component="div">
                        1. Each candidate
                        is assessed by judges, guided by the rubric. Technical and Musicianship scores are added
                        together for a total score out of 10 from each judge
                        <br/>
                        2.
                        All 5 judges
                        write a short comment for each applicant
                        <br/>

                        3.
                        The best candidates
                        are selected for round 2

                    </Typography>

                    <Typography sx={{mt: 0}} gutterBottom variant="h6" component="div">
                        Round two (live)
                    </Typography>

                    <Typography sx={{mt: 0, lineHeight: 1.9}} gutterBottom variant="body" component="div">
                        1.
                        Each candidate
                        is assessed by judges, guided by the rubric. Technical and Musicianship scores are added
                        together for a total score out of 10 from each judge
                        <br/>

                        2.
                        Highest and lowest
                        score is eliminated, and an average score is made from the remaining 3 scores
                        <br/>

                        3.
                        All 5 judges
                        write a short comment for each applicant
                        <br/>

                        4.
                        If there are
                        any discrepancies in the opinions, there can be a discussion and a re-vote
                        <br/>

                        5.
                        The best candidates
                        are selected for round 3
                    </Typography>

                    <Typography sx={{mt: 0}} gutterBottom variant="h6" component="div">
                        Round three (Final round)
                    </Typography>

                    <Typography sx={{mt: 0, lineHeight: 1.9}} gutterBottom variant="body" component="div">
                        1.
                        Each candidate
                        is assessed by judges, guided by the rubric. Technical and Musicianship scores are added
                        together for a total score out of 10 from each judge
                        <br/>

                        2.
                        Discussion and
                        final decision
                    </Typography>


                    <img className={'rubric-image'} alt={'rubric'}
                         src={'/Images/Altenberg/rubric.png'}/>

                    <Typography sx={{mt: 0}} gutterBottom variant="h6" component="div">
                        Feedback from each judge to each candidate
                    </Typography>

                    <Typography sx={{mt: 0, lineHeight: 1.9}} gutterBottom variant="body" component="div">
                        Included:
                        what is going well and some advice for improvement
                    </Typography>
                </Grid>
                <Grid item sm={0} md={2}>
                </Grid>
            </Grid>
        </div>
    )
}